import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon , ArrowUpIcon} from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import {  decreaseExerciseFileOrder, deleteExercise, deleteExerciseFile } from "../actions";
import { useActionState, useEffect } from "react";
import { ExerciseFile } from "../../../../models";

export function CreateButton() {
  return (
    <Link to={"/admin/exercises/create"} className="contents">
      <Button className="mt-4">
        Create
        <Icon icon={PlusIcon} label="Create Feature" className="ml-1" />
      </Button>
    </Link>
  );
}


export function UpdateButton({ id }: { id: string }) {
  return (
    <Link to={`/admin/exercises/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}


export function DeleteButton({ id }: { id: string }) {
  const navigate = useNavigate();

  const deleteExerciseWithId = deleteExercise.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this exercise?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteExerciseWithId, {
    success: false,
    message: "",
  });

  useEffect(() => {
    if (state.success) {
      navigate(`/admin/exercises?reload=${Date.now()}`, { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}

export function DeleteAppFileButton({ id,onReload }: { id: string,onReload:()=>void }) {
 

  const deleteExerciseFileWithId = deleteExerciseFile.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this exercise file?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteExerciseFileWithId, {
    success: false,
    message: "",
  });

  useEffect(() => {
    if (state.success && onReload) {
      onReload();
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
  
}
 

export function DecreaseExerciseFileOrderButton({ file,onSuccess }: { file: ExerciseFile ,onSuccess:()=>void}){
  
  const updateWithId = decreaseExerciseFileOrder.bind(null, file.id||"");
  const [state, formAction, isPending] = useActionState(updateWithId, {success:false});
  useEffect(()=>{
    console.log({state})
    if(state.success){
      onSuccess();
    
    }
  },[state])
  return (
    <form action={formAction}  >
      <input type="hidden" name="orderNumber" value={file.orderNumber} />
      <input type="hidden" name="exerciseId" value={file.exerciseId} />
      <input type="hidden" name="appFileId" value={file.appFileId} />
      <IconButton label='Up' icon={ArrowUpIcon} loading={isPending}></IconButton>   
    </form>
  );
}

